import { Button, Skeleton, DatePicker, Card, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { TimePicker } from "antd";
import {
  calculateDateRangeFromDate,
  generatedISOFormatDateString,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";
import { useSelector } from "react-redux";
import TreeSelectCustomWithSelectAll from "../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import * as echarts from 'echarts';



const { RangePicker } = TimePicker;

 
const TempHistoricalTrends = () => {
  const {  makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);
  const [chartInput, setChartInput] = useState(null);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const chartRef = useRef(null);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  console.log(isdarkMode);

  const [data1,setData1]= useState([]);
  const [data2,setData2]= useState([]);
  const [loading, setLoading] = useState(true);
  const simulateLoading = (setLoading) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoading);
  },[])


  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        id: "historical-trends",
        height: 350,
        type: "line",
        zoom: {
          type: "x",
          enabled: true,
          // autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
          // export: {
          //   csv: {
          //     filename: undefined,
          //     columnDelimiter: ',',
          //     headerCategory: 'category',
          //     headerValue: 'value',
          //     categoryFormatter(x) {
          //       return new Date(x).toDateString()
          //     },
          //     valueFormatter(y) {
          //       return y
          //     }
          //   },
          // }
        },
      },
      colors: [
        '#FF5733', '#33FF57', '#3357FF', '#F3FF33', '#33FFF9', '#FF33A6', '#B833FF',
        '#FF8D33', '#33FF8D', '#FF3381', '#3381FF', '#FFDB33', '#33FFDB', '#FF7033', '#33FF70','#7033FF', '#FF33C9', '#33FFC9', '#C933FF'
      ],
      legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        floating: false,
        fontSize: '14px',
        fontFamily: 'Helvetica, Arial',
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: 0,
        offsetY: 0,
        labels: {
            colors:  isdarkMode ? "#FFFFFF" : "#000000",
            useSeriesColors: false
        },
        markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
        },
        itemMargin: {
            horizontal: 5,
            vertical: 10
        },
        onItemClick: {
            toggleDataSeries: true
        },
        onItemHover: {
            highlightDataSeries: false
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 5,
        strokeOpacity: 0.3,
        hover: {
          size: undefined,
          sizeOffset: 3,
        },
      },
      title: {

        text: "Historicals Trends ",
        style: {
          color: isdarkMode ? "#FFFFFF" : "#000000",
          fontSize: "18px",
          fontWeight: "bold",
        },
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
          },
        },
        title: {
          text: "Date",
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
          },
        },
        title: {
          text: "Value",
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
      },
      tooltip: {
        x: {
          show: true,
          format: "dd-MMM",
          formatter: undefined,
        },
        y: {
          title: {
            formatter: (
              seriesName,
              { series, seriesIndex, dataPointIndex, w }
            ) => {
              const isFlowRate = seriesName.includes("flowRate");
              const kgLabel = isFlowRate ? " (°C)" : "(°C)";

              // Assuming opts.value contains the actual y-axis value
              return `${seriesName}  ${kgLabel}`;
            //   return seriesName ;
            },
          },
        },
      },
    },
  });

  const inputData = {
    SectionID: 1,
    ConverterorGroupID: 2,
    MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };




  useEffect(()=>{
    makeRequest({  
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        // url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
        url: `${APIConstants.TEMP_GETSITES}`
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
      });

    makeRequest({  
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });
   
  },[])

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.TEMP_METERS_LIST}?SiteID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId])

  
  const getResponse =(inputData)=>{
    console.log(inputData)
    
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // http://20.244.40.160:81/TVSDashBoard/GetsteamHistoricalDetails?SectionID=1&ConverterorGroupID=24&MeterIds=21,22,23&FromDate=2024-7-11T13:08:50.000Z&ToDate=2024-7-19T13:08:55.000Z
        url: `${APIConstants.GET_HISTORICAL_TRENDS_TEMPERATURE}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}` 
      }).then((res) => {
        console.log(res)
        // setsteamHistoricalData(dummyResponse);
        setsteamHistoricalData(res);
        setIsLoading(false)
      });
  } 

  const getFlowSectionList =  (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList = 
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList = 
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList = 
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList = 
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    console.log(values)
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      MeterIds: ids || [1],
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    getResponse(inputData)
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  }, [steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(true); 
    }
  };

  const updateChart = async () => {
    console.log(steamHistoricalData)
    console.log(selectedMeterIds)
    try {
      setChartLoading(true);
      const selectedMeterData = steamHistoricalData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      console.log(selectedMeterData)
      // transform the data in a chart series format
      const transformData = (property, meterName) => {
        const data = selectedMeterData
          ?.filter((item) => item?.metername === meterName)
          ?.map((item) => item[property]);
        const seriesData = {
          type:'line',
          name: `${property}-${meterName}`, // Concatenate property and METERNAME
          stack: 'Total',
          data,
        };
        return seriesData;
      };
      const properties = selectedValues;
      const seriesData = [];

      console.log(nsGetFlowConverterList)
      // Iterate over selected meter IDs and properties
      selectedMeterIds?.forEach((id) => {
        const meterName = 
          sectionId === 1
            ? nsGetFlowConverterList?.find(
                (item) => item?.meteR_METERID === Number(id)
              ).metername
            : getFlowSteamGroupMeterList?.find(
                (item) => item?.meterID === Number(id)
              ).meterName;
        properties.forEach((property) => {
          seriesData.push(transformData(property, meterName));
        });
      });

      console.log(seriesData)

      const datesArray = [];
      const date = ["createdON"];
      selectedMeterIds?.forEach((id) => {
        const meterName =
          sectionId === 1
            ? nsGetFlowConverterList?.find(
                (item) => item?.meteR_METERID === Number(id)
              ).metername
            : getFlowSteamGroupMeterList?.find(
                (item) => item?.meterID === Number(id)
              ).meterName;
        date.forEach((property) => {
          datesArray.push(transformData(property, meterName));
        });
      });
      console.log(selectedMeterIds)
      console.log(datesArray)
      const firstOption = selectedValues.includes("rh");
      const secondOption = selectedValues.includes("temperature");
      const finalData = seriesData?.filter((series) => {
        if (firstOption && secondOption) {
          // Both options selected, keep all series
          return true;
        } else if (firstOption) {
          // First option selected, add series with "rh"
          return series.name.includes("rh");
        } else if (secondOption) {
          // Second option selected, add series with "temperature"
          return series.name.includes("temperature");
        }
        // If neither option selected, keep all series
        return true;
      });

      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);

      const reversedFinalData = finalData.map((data) => {
        return { data: data.data.reverse(), name: data.name,stack: 'Total',type:'line' };
      });

      // // x axis input
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      // update in columnData
      setData1(reversedFinalData)
      setData2(localDateTime)
      setChartData((prevChartData) => ({
        series: reversedFinalData || [],
        options: {
          ...prevChartData.options,
          xaxis: {
            ...prevChartData.options.xaxis,
            categories: localDateTime || [],
          },
          yaxis: {
            title: {
              text: selectedValues.join(",".toString()),
            },
          },
        },
      }));
      setChartLoading(false);
    } catch (err) {
      console.log(err);
      setChartLoading(false);
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };
 

  useEffect(() => {
    setChartData((prevChartData) => ({
      series: prevChartData.series || [],
      options: {
        ...prevChartData.options,
        chart:{
            background:` ${isdarkMode ? '#2d3748':'inherit'}`,
            export: {
              csv: {
                download: false, // Disable CSV download
                filename: undefined,
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                categoryFormatter(x) {
                  return new Date(x).toDateString()
                },
                valueFormatter(y) {
                  return y
                }
              },
            },
        },
        legend: {
          ...prevChartData.options.legend,
          labels: {
            ...prevChartData.options.legend.labels,
            colors: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
        xaxis: {
          ...prevChartData.options.xaxis,
          labels: {
            ...prevChartData.options.xaxis.labels,
            style: {
              colors: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
          title: {
            ...prevChartData.options.xaxis.title,
            style: {
              color: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
        },
        yaxis: {
          ...prevChartData.options.yaxis,
          labels: {
            ...prevChartData.options.yaxis.labels,
            style: {
              colors: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
          title: {
            text: selectedValues.join(",".toString()),
            ...prevChartData.options.yaxis.title,
            style: {
              color: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
        },
        title: {
          ...prevChartData.options.title,
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
      },
    }));
  }, [isdarkMode,selectedValues]);
  

  const parameters = [
    { id: 1, name: "rh" },
    { id: 2, name: "temperature" },
  ];


  console.log(chartData)



  useEffect(() => {
    // if (!chartRef.current || barChartData.length === 0) return;
    console.log(data1)
    console.log(data2)

    if(data1&& data2){
      
    const myChart = echarts.init(chartRef.current);

    // Option for the chart     
    const option = {
      backgroundColor: isdarkMode ? '#2d3748' : '#fff', 
      title: {
        text: `Historical Trends`,
        left: 'center',
        top: '5px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black'  
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'line'  // Keep axis pointer type as 'line' for line chart
        }
      },
      toolbox: {
        show: true,
        feature: {
          magicType: { 
            type: ['line', 'bar'],
            iconStyle: {
              borderColor: isdarkMode ? 'white' : 'black'  // Icons for line/bar type switch
            }
          },
          saveAsImage: {
            title: 'Save Image',
            iconStyle: {
              borderColor: isdarkMode ? 'white' : 'black'  // Save image icon color
            }
          }
        },
        iconStyle: {
          borderColor: isdarkMode ? 'white' : 'black'  // General icon color based on theme
        }
      },
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black'  // Change legend text color based on theme
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '20%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: data2,  // Assuming data2 contains the x-axis labels
        axisLabel: {
          color: isdarkMode ? 'white' : 'black',  // Change x-axis label color based on theme
          interval: 5,
          rotate: 45,  // Rotate labels by 45 degrees to prevent overlap
          formatter: function (value) {
            return value;
          }
        },
        boundaryGap: false  // Ensure the line starts from the axis
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: isdarkMode ? 'white' : 'black',  // Change y-axis label color based on theme
          fontSize: '10',
          fontWeight: 'bold' 
        }
      },
      series: data1,  // Assuming data1 contains the series data for the line chart
    };
    
    
    myChart.setOption(option);

    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);

    return () => {
        window.removeEventListener('resize', resizeHandler);
        myChart.dispose();
    };}
}, [data1,data2,isdarkMode]);


  return (
    <div id="chart" className={`relative bg-white p-4 rounded-md dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
      {/* {loading  &&(
        <div className="absolute inset-0 flex justify-center items-center  dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div>
      )} */}
      

      
      <Card 
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
         {
          !data1.length >0 && !loading &&
          <div className="text-3xl">
          <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          </div> 
         }
          {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
        <div ref={chartRef} className={`${loading  ? 'h-0':'min-h-[650px]'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>
        
        </Card>

        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll 
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <SteamTreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"        
            nameKey="name"     
            valueKey="name"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button> 
        </div>
      </CustomDrawer>
    </div>
  );
};

export default TempHistoricalTrends
